const jscookies = require('js-cookie')

/**
 * Crea un nuevo registro dentro de las cookies de una sesion de una aplicacion en especifico.
 */
function CreateCookies (keyapp, keysesion) {
  jscookies.set(`MEDISOFT-OAUTH-${keyapp}`, keysesion)
}

/**
 * Obtiene las cookies de una sesion de una aplicacion en especifico.
 */
function GetCookies (keyapp) {
  return jscookies.get(`MEDISOFT-OAUTH-${keyapp}`)
}

function DeleteCookies (keyapp) {
  return jscookies.remove(`MEDISOFT-OAUTH-${keyapp}`)
}

export default {
  CreateCookies,
  GetCookies,
  DeleteCookies
}
